/**
 * investigation detao; service
 */

import { apiConfig, createAxiosServiceInstance } from '../api';
import moment from 'moment';
import { dateTimeFormat } from '../../util/GlobalConstant';
import {
  AMLS_COMMON,
  AMLS_NS_SAM
} from '../../pages/constants/globalConstants';

const axios = createAxiosServiceInstance();
const baseUrl = `${apiConfig.serviceApi}${AMLS_COMMON}/alerts/`;
const hitsBaseUrl = `${apiConfig.serviceApi}${AMLS_NS_SAM}/hits`;
const headers = {
  'Content-Type': 'application/json'
};

export async function getInvestDetailData(payload) {
  const { alertId, alertType } = payload;
  const params = { alertType };

  const url = `${baseUrl}${alertId}`;
  return await axios.get(url, { headers, params }).then((res) => {
    return {
      alert: {
        ...res.data,
        alertDate: res.data.alertDate
          ? moment
              .utc(res.data.alertDate, [dateTimeFormat])
              .local()
              .format('DD/MM/YYYY')
          : '',
        partyDob: res.data.partyDob
          ? moment
              .utc(res.data.partyDob, [dateTimeFormat])
              .local()
              .format('DD/MM/YYYY')
          : '',
        closureDate: res.data.closureDate
          ? moment
              .utc(res.data.closureDate, [dateTimeFormat])
              .local()
              .format('DD/MM/YYYY')
          : '',
        typeOfAlert: '-',
        customerGender:
          res.data.customerGender === 'NULL' || !res.data.customerGender
            ? '-'
            : res.data.customerGender
      }
    };
  });
}

export async function getInvestDetailHits(payload) {
  const { limit, offset } = payload;
  const params = {
    ...payload,
    limit: limit || 5,
    offset: offset || 0
  };

  return await axios.get(hitsBaseUrl, { headers, params }).then((res) => {
    return {
      ...res.data
    };
  });
}

export async function getInvestDetailPastHits(payload) {
  const { limit, offset, watchlistId, bankCustomerId, alertType, alertId } =
    payload;
  const params = {
    alertId,
    bankCustomerId,
    alertType,
    limit: limit || 5,
    offset: offset || 0
  };

  const url = `${hitsBaseUrl}/${watchlistId}/pastHits`;
  return await axios.get(url, { headers, params }).then((res) => {
    return {
      ...res.data
    };
  });
}
